import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const EmailsPage = lazy(() => import('@/pages/emails'));

export const Route = createFileRoute('/emails')({
  component: function EmailsRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <EmailsPage />
      </Suspense>
    );
  },
});
